import React from "react";

const Logo = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      fill="none"
      viewBox="0 0 32 32"
    >
      <path
        fill="url(#svg-icon__a)"
        d="M23.505 9.439c-.904.226-4.07.678-5.54.876-1.386 1.197-3.653 3.54-1.64 3.336 2.516-.255 6.417-1.103 8.17-1.696.932-.316 1.082-1.468.621-2.064-.405-.524-1.082-.585-1.611-.452"
      />
      <path
        fill="url(#svg-icon__b)"
        d="M4.876 12.492c.39 2.044 3.637 2.016 5.23 1.837-.717 1.065-2.25 4.037-2.658 7.407-.508 4.212 2.403 8.514 7.859 8.282 4.664-.198 8.763-4.438 10.968-7.18s.65-4.919-.198-5.739-3.618-1.78-5.569 1.442c-1.95 3.223-4.636 5.371-6.275 4.947s-.566-3.646 0-4.947c.565-1.3 5.003-9.809 6.05-12.127C21.836 3.446 19 .842 16.606 2.513a382 382 0 0 1-9.47 6.389c-1.224.793-2.65 1.546-2.261 3.59"
      />
      <path
        fill="url(#svg-icon__c)"
        d="m16.696 13.61.064-.126c.544-1.071 1.112-2.188 1.636-3.228 1.586-.218 4.285-.611 5.109-.817.529-.133 1.206-.072 1.611.452.46.596.31 1.748-.622 2.064-1.668.565-5.284 1.36-7.798 1.655"
      />
      <path
        fill="url(#svg-icon__d)"
        d="M6.125 13.938c2.313-.5 4.688-1.938 6.27-3.227-1.082 1.726-2.27 3.601-2.27 3.601-.763.085-2.53.22-4-.374"
      />
      <defs>
        <linearGradient
          id="svg-icon__a"
          x1="25.343"
          x2="15.505"
          y1="9.976"
          y2="12.407"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FD00CF" />
          <stop offset="1" stopColor="#FD00CF" />
        </linearGradient>
        <linearGradient
          id="svg-icon__b"
          x1="10.006"
          x2="24.513"
          y1="5.049"
          y2="27.662"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset=".066" stopColor="#FF0451" />
          <stop offset=".207" stopColor="#FF006A" />
          <stop offset=".378" stopColor="#FC1FA4" />
          <stop offset=".544" stopColor="#FE00CF" />
          <stop offset=".816" stopColor="#B30CE4" />
          <stop offset="1" stopColor="#8204FF" />
        </linearGradient>
        <linearGradient
          id="svg-icon__c"
          x1="7.125"
          x2="20.688"
          y1="11.875"
          y2="16.975"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset=".065" stopColor="#92077F" stopOpacity="0" />
          <stop offset=".285" stopColor="#8D067D" />
          <stop offset=".678" stopColor="#8D008C" />
          <stop offset=".912" stopColor="#8E067E" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="svg-icon__d"
          x1="7.125"
          x2="20.688"
          y1="11.875"
          y2="16.975"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset=".065" stopColor="#92077F" stopOpacity="0" />
          <stop offset=".285" stopColor="#8D067D" />
          <stop offset=".678" stopColor="#8D008C" />
          <stop offset=".912" stopColor="#8E067E" stopOpacity="0" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default Logo;
